// Color scheme per PRD Design System
export const colors = {
  primary: "#CC4E30", // Terracotta
  primaryBackground: "#FDFBF9", // Warm off-white
  secondary: "#93817E", // Soft clay gray (muted)
  primaryForeground: "#ffffff", // White foreground text

  // Additional colors for web-specific features
  gradients: {
    primary: "linear-gradient(135deg, #CC4E30 0%, #B03D22 100%)",
    secondary: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    success: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    warning: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    info: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
  },

  // Neutral colors
  background: {
    light: "#FDFBF9",
    dark: "#121212",
    paper: "#ffffff",
    paperDark: "#1e1e1e",
  },

  text: {
    primary: "#2C1810", // Near black with warm tone
    secondary: "#93817E", // Soft clay gray
    light: "#ffffff",
    dark: "#000000",
  },

  status: {
    success: "#28a745",
    warning: "#ffc107",
    error: "#dc3545",
    info: "#17a2b8",
  },

  // Header styling
  header: {
    background: "#2C1810",
    text: "#ffffff",
  },
};

export default colors;
